<app-report reportId="PriceEvolution" screen="PREV" [submenu]="true"></app-report>